export default "__VITE_ASSET__DDMKUyVa__"